import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ variant = "dark" }) => {
  const logoSrc =
    variant === "light" ? "/logo/logo-light.png" : "/logo/logo-dark.png";

  return (
    <div className="w-12">
      <Link to="/">
        <img
          src={logoSrc}
          alt="Logo"
          width={423}
          height={216}
          className="w-12 md:w-16 object-cover"
        />
      </Link>
    </div>
  );
};

export default Logo;
